module.exports = __webpack_public_path__ + "54e94ed2dda78e4f8a271458fac799a4.pdf";